import { Pipe, PipeTransform } from "@angular/core";
import moment from "moment";

@Pipe({
  name: "momentDate",
  standalone: true,
})
export class MomentDatePipe implements PipeTransform {
  transform(value: any, format: string = "HH:mm"): string {
    if (!value) {
      return "";
    }

    const date = moment(value);
    const now = moment();
    const today = moment().startOf("day");
    const tomorrow = moment().add(1, "days").startOf("day");
    const diffMinutes = date.diff(now, "minutes");

    if (diffMinutes < 5 && diffMinutes >= 0) {
      return "Starting soon";
    }

    if (diffMinutes >= 5 && diffMinutes <= 15) {
      return `Starting in ${diffMinutes}'`;
    }

    if (date.isSame(today, "day")) {
      return date.format("HH:mm");
    }

    if (date.isSame(tomorrow, "day")) {
      return `Tomorrow ${date.format("HH:mm")}`;
    }

    if (date.isAfter(tomorrow, "day")) {
      return `${date.format("dddd HH:mm")}`;
    }

    return date.format(format);
  }
}
